let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cRDzq")).then(() => parcelRequire('bwe76'));